import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import GMDSSEquipmentSummary from './pages/eps/GMDSSEquipmentSummary';
import FlowDiagram1 from './pages/eps/FlowDiagram1';
import FlowDiagram2 from './pages/eps/FlowDiagram2';
import SampleLogEntryTable1 from './pages/eps/table/table1/SampleLogEntryTable1';
import SampleLogEntryTable2 from './pages/eps/table/table2/SampleLogEntryTable2';
import SampleLogEntryTable3 from './pages/eps/table/table3/SampleLogEntryTable3';
import SampleLogEntryTable4 from './pages/eps/table/table4/SampleLogEntryTable4';
import SampleLogEntryTable5 from './pages/eps/table/table5/SampleLogEntryTable5';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';
import { commonUtils } from 'redux/_common';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type GMDSSEPSCoverPageProps = PropsFromRedux & OwnProps;
function GMDSSEPSCoverPage(props: GMDSSEPSCoverPageProps) {
    const { vesselInfo, globalSettings, listOfPersonnels, selectedDate } =
        props;
    const gmdssData = {
        sectionA: {
            nameOfShip: vesselInfo?.vesselName,
            callSign: vesselInfo?.callSign,
            mmsi: vesselInfo?.mmsiNumber,
            imoNo: vesselInfo?.imoNumber,
            officialNo: vesselInfo?.imoNumber, // Yet to be determined
            grossTonnage: vesselInfo?.tonnage?.grossTonnage,
            dateOfExpiryOfSafetyRadioCertificate:
                globalSettings?.gmddsRadioLogSectionA
                    ?.dateOfExpiryOfShipRadioCertificate,
            portOfRegistry: vesselInfo?.portOfRegistry,
            inmarsatA: globalSettings?.gmddsRadioLogSectionA?.inmarsatA,
            inmarsatB: globalSettings?.gmddsRadioLogSectionA?.inmarsatB,
            inmarsatC: globalSettings?.gmddsRadioLogSectionA?.inmarsatC,
            inmarsatM: globalSettings?.gmddsRadioLogSectionA?.inmarsatD,
            duplicationOfEquipment:
                globalSettings?.methodsOfRadioFacilities
                    ?.isDuplicationOfEquipment,
            shoreBasedMaintenance:
                globalSettings?.methodsOfRadioFacilities
                    ?.isShoreBasedMaintainance,
            atSeaMaintenanceCapability:
                globalSettings?.methodsOfRadioFacilities
                    ?.isAtSeaMaintainanceCapability,
            detailsOfServiceCompany: {
                name: globalSettings?.methodsOfRadioFacilities
                    ?.nameOfServiceCompany,
                address:
                    globalSettings?.methodsOfRadioFacilities
                        ?.addressOfServiceCompany,
            },
            detailsOfOwnerCompany: {
                name: globalSettings?.methodsOfRadioFacilities
                    ?.nameOfShipOwnerOrManager,
                address:
                    globalSettings?.methodsOfRadioFacilities
                        ?.addressOfShipOwnerOrManager,
            },
        },
        sectionB: {
            content: [] as any,
        },
    };

    listOfPersonnels?.forEach((personnel) => {
        const {
            name = '',
            rank = '',
            class_certificate = '',
			certificateNumber = '',
            onboard_date = '',
            date_of_issue = '',
            offboard_date = '',
        } = personnel;

        gmdssData?.sectionB?.content?.push({
            name,
            rank,
            certificateClass: class_certificate,
			certificateNumber: certificateNumber,
            dateOfIssue: date_of_issue,
            onboardDate: onboard_date,
            offboardDate: offboard_date,
        });
    });

    const { sectionA, sectionB } = gmdssData;
    const {
        nameOfShip,
        officialNo,
        callSign,
        mmsi,
        portOfRegistry,
        inmarsatA,
        inmarsatB,
        inmarsatC,
        inmarsatM,
        detailsOfOwnerCompany,
        detailsOfServiceCompany,
        duplicationOfEquipment,
        shoreBasedMaintenance,
        atSeaMaintenanceCapability,
    } = sectionA;

    return (
        <div className="text-base">
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">GMDSS Radio Logbook</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Vessel Name:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {nameOfShip}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Call Sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Official No:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {officialNo}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period From :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {selectedDate &&
                                        moment(selectedDate).format(
                                            'DD-MM-yyyy'
                                        )}{' '}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">To :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {selectedDate &&
                                        moment(selectedDate).format(
                                            'DD-MM-yyyy'
                                        )}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">
                                Working language of the ship:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page + third page */}
            <div className="flex flex-col justify-between py-6 px-16 mb-2 text-left print-page-break">
                <h2 className="text-2xl font-medium">
                    Instructions For Maintaining The GMDSS Log
                </h2>
                <div className="my-4">
                    <p>
                        In accordance with the provisions of SOLAS (1974)
                        Chapter IV, the GMDSS Log must be carried on board
                        ships. It should be retained near to the radio
                        installation (GMDSS). It must be available for
                        inspection by any person authorised by the Flag State
                        Administration or the authorised representative of
                        another Administration.
                    </p>
                </div>
                <ol className="list-roman ml-4">
                    {/* first-roman subpoint */}
                    <li className="mb-4">
                        <b>Completion of the GMDSS Log.</b>
                        <p className="mb-4">
                            This Log has been split up into three sections: A,
                            B, C, and an ANNEX. Please read these notes before
                            completing each section.
                        </p>
                        <ol className="list-decimal ml-4">
                            {/* subpoint 1 */}
                            <li className="my-2 mx-0">
                                <b>Section A</b>
                                <div className="flex flex-col">
                                    <div className="flex items-start my-1">
                                        <div className="min-w-10  mx-0">
                                            1.1
                                        </div>
                                        <div>
                                            Enter all the required particulars
                                            of the ship.
                                        </div>
                                    </div>
                                    <div className="flex items-start my-1">
                                        <div className="min-w-10  mx-0">
                                            1.2
                                        </div>
                                        <div>
                                            Enter the method(s) of ensuring the
                                            availability of the radio equipment,
                                            including details of the service
                                            company or companies if shore-based
                                            maintenance is the chosen means.
                                        </div>
                                    </div>
                                </div>
                            </li>
                            {/* subpoint 2 */}
                            <li className="my-2 mx-0">
                                <b>Section B</b>
                                <p className="my-1">
                                    Enter details of the qualified personnel on
                                    board, (ie the names, dates of signing on
                                    and signing off the vessel).
                                </p>
                            </li>
                            {/* subpoint 3 */}
                            <li className="my-2 mx-0">
                                <b>Section C</b>
                                <p className="my-1">
                                    This section comprises the diary record of
                                    the operation of the radio installation.
                                    Entries in this part of the log are to be
                                    prepared as following:
                                </p>
                                <div className="flex flex-col">
                                    <div className="flex items-start my-1">
                                        <div className="min-w-10  mx-0">
                                            3.1
                                        </div>
                                        <div>
                                            A summary of communications relating
                                            to Distress, urgency and Safety
                                            traffic. The summary must include
                                            dates and times, details of the
                                            vessels involved and their
                                            positions.
                                        </div>
                                    </div>
                                    <div className="flex items-start my-1">
                                        <div className="min-w-10  mx-0">
                                            3.2
                                        </div>
                                        <div>
                                            <p>
                                                A record of important incidents
                                                connected with the radio
                                                service. For example:
                                            </p>
                                            <div className="flex flex-col">
                                                <div className="flex items-start my-1">
                                                    <div className="min-w-10  mx-0">
                                                        (a)
                                                    </div>
                                                    <div>
                                                        a breakdown or serious
                                                        malfunction of the
                                                        equipment;
                                                    </div>
                                                </div>
                                                <div className="flex items-start my-1">
                                                    <div className="min-w-10  mx-0">
                                                        (b)
                                                    </div>
                                                    <div>
                                                        a breakdown of
                                                        communications with
                                                        coast stations, coast
                                                        earth stations or
                                                        satellites;
                                                    </div>
                                                </div>
                                                <div className="flex items-start my-1">
                                                    <div className="min-w-10  mx-0">
                                                        (c)
                                                    </div>
                                                    <div>
                                                        any significant
                                                        incidents concerning the
                                                        non-receipt of messages
                                                        etc.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-start my-1">
                                        <div className="min-w-10  mx-0">
                                            3.3
                                        </div>
                                        <div>
                                            The position of the ship at least
                                            once a day. The position may be
                                            given relative to a geographical
                                            point, if appropriate, as an
                                            alternative to its latitute and
                                            longitude, even if at berth.
                                        </div>
                                    </div>
                                    <div className="flex items-start my-1">
                                        <div className="min-w-10  mx-0">
                                            3.4
                                        </div>
                                        <div>
                                            The details of the tests and checks
                                            carried out on the equipment. (see
                                            Annex).
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ol>
                    </li>
                    {/* second-roman subpoint */}
                    <li className="mb-4 print:pt-6">
                        <b>Notes on The Keeping Of The Log.</b>
                        <p className="my-4">
                            The Master must nominate one or more crew members,
                            normally the person(s) qualified for distress and
                            safety radio communications under the Regulations,
                            to maintain the Log and to carry out the tests and
                            checks of the equipment required by SOLAS
                            Regulations.
                        </p>
                        <p className="mb-4">
                            Distress and distress - related communications
                            received as hard copy via Navtex, Enhanced Group
                            Calling (ECG), Narrow Band Direct Printing or
                            satellite telex should be noted in the Log and filed
                            on board.
                        </p>
                        <p className="mb-4">
                            Daily, weekly and monthly tests and checks of
                            equipment and reserve power as set out in the Annex
                            to these Instructions, must be entered into the Log
                            on completion. A brief summary of the operational
                            capability of the equipment together with the names
                            of any station contacted during tests should be
                            recorded. If any of the radio equipment is found not
                            to be in full working order the nominated person
                            must notify the Master and record details of the
                            deficiencies in the Log.
                        </p>

                        <p className="mb-4">
                            Pre-sailing checks to ensure that all equipment is
                            in an efficient working condition. Masters Training
                            (Instructions & Information) to all relevant crew
                            members on GMDSS equipment, including sending a
                            distress message as and when a crew change is
                            effected or more frequently if the need be felt.
                        </p>
                    </li>
                    {/* third-roman subpoint */}
                    <li className="mb-4">
                        <b>Inspection Of The Log.</b>
                        <p className="my-4">
                            The Master must inspect the Log daily and sign the
                            log upon completion of each page.
                        </p>
                    </li>
                    {/* fourth-roman subpoint */}
                    <li>
                        <b>Retention Of The Log.</b>
                        <p className="my-4">
                            This Log must be retained on board for a Period of
                            THREE years from the date of last entry.
                        </p>
                    </li>
                </ol>
            </div>
            {/* Fourth page + Fifth page */}
            <div className="flex flex-col justify-between py-6 pt-0 px-16 mb-2 mt-0 text-left  print-page-break">
                <h2 className="text-2xl uppercase text-center print:mt-4">
                    {' '}
                    Annex
                </h2>
                <h3 className="text-xl font-semibold my-4 print:my-8">
                    Equipment Tests and Reserves Power Checks
                </h3>
                <ol className="list-decimal ml-4 marker:text-lg">
                    <li className="mb-1 print:mb-4">
                        <p className="mb-2 text-lg">Daily</p>
                        <div className="flex flex-col">
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">1.1</div>
                                <div>
                                    The proper fuctioning of the DSC Facilities
                                    shall be tested at least once each day,
                                    without radiation of signals, by use of the
                                    means provided on the equipment.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">1.2</div>
                                <div>
                                    Batteries providing a source of energy for
                                    any part of the radio installations shall be
                                    tested daily and, where necessary, brought
                                    up to the fully charged condition. Indicate
                                    the battery ON/OFF Load voltage.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">1.3</div>
                                <div>
                                    Printer (s) shall be checked daily to ensure
                                    there is an adequate supply of paper.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">1.4</div>
                                <div>
                                    Ships position in Lat/Log even if ship is at
                                    berth.
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="my-1 print:mb-4">
                        <p className="mb-2 text-lg">Weekly</p>
                        <div className="flex flex-col">
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">2.1</div>
                                <div>
                                    The Proper operation of the DSC facilities
                                    shall be tested at least once a week by
                                    means of a test call when within
                                    communication range of a coast station
                                    fitted with DSC equipment. Where a ship has
                                    been out of communication range of a coast
                                    station fitted with DSC equipment for a
                                    period of longer than one week, a test call
                                    shall be made on the first opportunity that
                                    the ship is within communication range of
                                    such a coast station.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">2.2</div>
                                <div>
                                    Where the reserve source of energy is not a
                                    battery (for example, a motor generator),
                                    the reserve source of energy shall be tested
                                    weekly.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">2.3</div>
                                <div>
                                    Results of the weekly hydrometer or load
                                    test of batteries
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="my-1 print:mb-4">
                        <p className="mb-2 text-lg">Monthly</p>
                        <div className="flex flex-col">
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">3.1</div>
                                <div>
                                    Each EPIRB and satellite EPIRB shall be
                                    tested at least once a month to detremine
                                    its capability to operate properly using the
                                    means provided on the device and without
                                    using the satellite system.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">3.2</div>
                                <div>
                                    Each Search and Rescue Radar Tranponder
                                    (SART) shall be checked at least once a
                                    month using the in-built test facility and
                                    checked for security and signs of damage.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">3.3</div>
                                <div>
                                    A check shall be made at least once a month
                                    on the security and condition of all
                                    batteries providing a source of energy for
                                    any part of a radio installation. The
                                    battery connections and compartment shall
                                    also be checked.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">3.4</div>
                                <div>
                                    A check shall be made at least once a month
                                    the conditions of all aerial and insulators.
                                </div>
                            </div>
                            <div className="flex items-start my-1">
                                <div className="min-w-10  mx-0">3.5</div>
                                <div>
                                    Each survival craft two-way VHF equipment
                                    shall be tested at least once a month on a
                                    frequency other than 156.8 Mhz (VHF Channel
                                    16).
                                </div>
                            </div>
                        </div>
                    </li>
                </ol>
            </div>
            {/* Sixth page + Seventh page */}
            <div className="flex flex-col justify-between py-6 pt-0 px-16 mb-2 text-left">
                <h3 className="text-xl font-semibold mt-4">Section A</h3>
                <h4 className="uppercase text-lg font-medium py-4">
                    Particulars of ship
                </h4>
                <div className="flex flex-col">
                    <div className="flex items-center mb-2 text-base">
                        <p className="mr-2 min-w-fit mb-0">Name of ship:</p>
                        <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                            {nameOfShip}
                        </p>
                    </div>
                    <div className="flex w-full space-x-2 my-4">
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">Call sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">MMSI:</p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {mmsi}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                Port of Registry:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {portOfRegistry}
                            </p>
                        </div>
                    </div>
                    <div className="flex w-full space-x-2 my-4">
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                INMARSAT A No.:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {inmarsatA}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                INMARSAT B No.:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {inmarsatB}
                            </p>
                        </div>
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                INMARSAT C No.
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {inmarsatC}
                            </p>
                        </div>
                    </div>
                    <div className="flex w-full space-x-2 my-4">
                        <div className="basis-1/3 flex">
                            <p className="mr-2 min-w-fit mb-0">
                                INMARSAT M No.:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                {inmarsatM}
                            </p>
                        </div>
                    </div>

                    <div className="my-4">
                        <p>
                            Indicate method(s) used to ensure availability of
                            radio facilities: (tick appropriate box):
                        </p>
                        <div className="flex justify-center">
                            <div className="w-2/3 mt-4">
                                <table className="w-full border preserve-tablestylesin-pagedjs">
                                    <thead style={{ background: 'none' }}>
                                        <tr>
                                            <th
                                                className="p-2"
                                                style={{ width: 400 }}
                                            ></th>
                                            <th className="font-medium uppercase p-2">
                                                Yes
                                            </th>
                                            <th className="font-medium uppercase p-2">
                                                No
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border-none p-2">
                                                a&#x29; Duplication of equipment{' '}
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {duplicationOfEquipment ? (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    ) : null}
                                                </div>
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {duplicationOfEquipment ? null : (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border-none p-2">
                                                b&#x29; Shore-based maintenance
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {shoreBasedMaintenance ? (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    ) : null}
                                                </div>
                                            </td>
                                            <td className="border-none p-2">
                                                <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                    {shoreBasedMaintenance ? null : (
                                                        <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* Seventh Page */}
                    <div className="newpage my-4 mt-8">
                        <p className="mb-4">Details of service company:</p>
                        <div className="flex justify-center">
                            <div style={{ width: '80%' }}>
                                <div className="flex mb-2 items-center">
                                    <div style={{ width: 120 }}>Name:</div>
                                    <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                        {detailsOfServiceCompany?.name}
                                    </p>
                                </div>
                                <div className="flex mb-2 items-start">
                                    <div
                                        className="mt-2"
                                        style={{ width: 120 }}
                                    >
                                        Address:
                                    </div>
                                    <div className="w-full">
                                        <p
                                            style={{ paddingTop: '0.7rem' }}
                                            className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                        >
                                            {detailsOfServiceCompany?.address?.slice(
                                                0,
                                                50
                                            )}
                                        </p>
                                        {detailsOfServiceCompany?.address?.slice(
                                            50,
                                            100
                                        ) ? (
                                            <p
                                                style={{ paddingTop: '0.7rem' }}
                                                className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                            >
                                                {detailsOfServiceCompany?.address?.slice(
                                                    50,
                                                    100
                                                )}
                                            </p>
                                        ) : null}
                                        {detailsOfServiceCompany?.address?.slice(
                                            100,
                                            150
                                        ) ? (
                                            <p
                                                style={{ paddingTop: '0.7rem' }}
                                                className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                            >
                                                {detailsOfServiceCompany?.address?.slice(
                                                    100,
                                                    150
                                                )}
                                            </p>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <div className="flex justify-center">
                                <div className="w-2/3 mt-4">
                                    <table className="w-full border preserve-tablestylesin-pagedjs">
                                        <thead style={{ background: 'none' }}>
                                            <tr>
                                                <th
                                                    className="p-2"
                                                    style={{ width: 400 }}
                                                ></th>
                                                <th className="font-medium uppercase p-2">
                                                    Yes
                                                </th>
                                                <th className="font-medium uppercase p-2">
                                                    No
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="border-none p-2">
                                                    At sea maintenance
                                                    capability:
                                                </td>
                                                <td className="border-none p-2">
                                                    <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                        {atSeaMaintenanceCapability ? (
                                                            <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                        ) : null}
                                                    </div>
                                                </td>
                                                <td className="border-none p-2">
                                                    <div className="w-5 h-5 border text-gray-600 flex justify-center items-center">
                                                        {atSeaMaintenanceCapability ? null : (
                                                            <span className="bp3-icon bp3-icon-tick text-sm text-gray-700" />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-4">
                        <p className="my-4">
                            Name and Address of Owner, Managing Owner or Agent:
                        </p>
                        <div className="flex justify-center">
                            <div style={{ width: '80%' }}>
                                <div className="flex mb-2 items-center">
                                    <div style={{ width: 120 }}>Name:</div>
                                    <p className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full mb-0 self-end">
                                        {detailsOfOwnerCompany?.name}
                                    </p>
                                </div>
                                <div className="flex mb-2 items-start">
                                    <div
                                        className="mt-2"
                                        style={{ width: 120 }}
                                    >
                                        Address:
                                    </div>
                                    <div className="w-full">
                                        <p
                                            style={{ paddingTop: '0.2rem' }}
                                            className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                        >
                                            {detailsOfOwnerCompany?.address?.slice(
                                                0,
                                                50
                                            )}
                                        </p>
                                        {detailsOfOwnerCompany?.address?.slice(
                                            50,
                                            100
                                        ) ? (
                                            <p
                                                style={{ paddingTop: '0.2rem' }}
                                                className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                            >
                                                {detailsOfOwnerCompany?.address?.slice(
                                                    50,
                                                    100
                                                )}
                                            </p>
                                        ) : null}
                                        {detailsOfOwnerCompany?.address?.slice(
                                            100,
                                            150
                                        ) ? (
                                            <p
                                                style={{ paddingTop: '0.2rem' }}
                                                className="inline-block px-3 text-[#808080] border-b  border-[#808080] w-full self-end"
                                            >
                                                {detailsOfOwnerCompany?.address?.slice(
                                                    100,
                                                    150
                                                )}
                                            </p>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Eighth page */}
            <div className="flex flex-col justify-between py-6 pt-0 px-16 mb-2 text-left print-page-break">
                <h2 className="text-xl font-semibold my-4 mb-0">Section B</h2>
                <h4 className="my-2">Qualified Personnel</h4>
                <table className="table-auto preserve-tablestylesin-pagedjs mb-4">
                    <thead className="border border-gray-500">
                        <tr>
                            <th className="p-2 text-center border border-gray-500">
                                NAME
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Rank
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Certificate Class
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Certificate Number
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Date S/On
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Date S/Off
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sectionB?.content?.map(
                            (rowData: any, index: number) => {
                                const {
                                    name,
                                    rank,
                                    certificateClass,
									certificateNumber,
                                    offboardDate,
                                    onboardDate,
                                } = rowData;

                                return (
                                    <tr key={index}>
                                        <td className="p-0.5 border border-gray-500">
                                            {name}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {rank}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {certificateClass}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {certificateNumber}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {onboardDate ? onboardDate.split('T')[0] : ''}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {/* Offboard date can be empty */}
                                            {offboardDate ? offboardDate.split('T')[0] : ''}
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>

            {/* Ninth page */}
            <div className="flex flex-col justify-between py-6 pt-0 px-16 mb-2 text-left print-page-break">
                <h4 className="my-2">
                    Designated personnel for radio communications during
                    emergencies
                </h4>
                <table className="table-auto preserve-tablestylesin-pagedjs mb-4">
                    <thead className="border border-gray-500">
                        <tr>
                            <th className="p-2 text-center border border-gray-500">
                                NAME
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Rank
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Certificate Class
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Certificate Number
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Date S/On
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Date S/Off
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {listOfPersonnels
                            .filter(
                                (personnel) => personnel.radio_comm_emergency
                            )
                            .map((personnel) => {
                                return (
                                    <tr key={personnel.staffId}>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.name}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.rank}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.class_certificate}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.certificateNumber}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel?.onboard_date ? personnel.onboard_date.split('T')[0] : ''}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {/* Offboard date can be empty */}
                                            {personnel?.offboard_date ? personnel.offboard_date.split('T')[0] : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

                <h4 className="my-2">
                    Designated personnel to carry out appropriate test, checks
                    and log entries
                </h4>
                <table className="table-auto preserve-tablestylesin-pagedjs mb-4">
                    <thead className="border border-gray-500">
                        <tr>
                            <th className="p-2 text-center border border-gray-500">
                                NAME
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Rank
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                               	Certificate Class
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Certificate Number
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Date S/On
                            </th>
                            <th className="p-2 text-center border border-gray-500">
                                Date S/Off
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {listOfPersonnels
                            .filter((personnel) => personnel.radio_tests)
                            .map((personnel) => {
                                return (
                                    <tr key={personnel.staffId}>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.name}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.rank}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.class_certificate}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel.certificateNumber}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {personnel?.onboard_date ? personnel.onboard_date.split('T')[0] : ''}
                                        </td>
                                        <td className="p-0.5 border border-gray-500">
                                            {/* Offboard date can be empty */}
                                            {personnel?.offboard_date ? personnel.offboard_date.split('T')[0] : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>

            {/* Tenth Page */}
            <GMDSSEquipmentSummary />
            <SampleLogEntryTable1 />
            <SampleLogEntryTable2 />
            <SampleLogEntryTable3 />
            <SampleLogEntryTable4 />
            <SampleLogEntryTable5 />
            <FlowDiagram1 />
            <FlowDiagram2 />
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);	
	const globalSettings = vesselSelectors.getGlobalSettings(vesselStore);
    const listOfPersonnels = commonUtils.objectToArray(
        vesselStore.logbookPersonnels
            ? vesselStore.logbookPersonnels
            : { byIds: {}, ids: [] }
    );
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        globalSettings,
        listOfPersonnels,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(GMDSSEPSCoverPage);
